import stateRequest from './stateRequest';
import mutations from './mutations';
import actions from './actions';

export default {
    state: stateRequest,
    mutations,
    actions,
    namespaced: true
}